import React, { useState, useEffect, useRef } from "react";
import { Controller } from "react-hook-form";
import { InputAdornment, TextField } from "@mui/material";
import { styled } from "@mui/material/styles";

const AdornmentText = styled(InputAdornment)({
  '& .MuiTypography-root': {
    color: '#737373',
    fontSize: '13px',
    fontWeight: 500,
  },
});

export const FormInputComma = ({
  name = "",
  control,
  disabled = false,
  label,
  placeholder,
  sx,
  size = "small",
  variant = "outlined",
  initialValue = "",
  onAmountChange,
  // 입력값 뒤에 붙는 단위 텍스트 (예: 'P'). 지정하지 않으면 기존과 동일하게 미노출.
  endAdornmentText,
}) => {
  const formatInteger = (value) => {
    if (!value) return '';
    const numericValue = value.toString().replace(/[^0-9]/g, '');
    return numericValue.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };

  const removeCommas = (value) => {
    if (!value) return '';
    return value.toString().replace(/,/g, '');
  };

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <TextField
          value={value ? formatInteger(value.toString()) : ''}
          onChange={(e) => {
            const rawValue = e.target.value;
            const numericValue = removeCommas(rawValue);
            onChange(numericValue);
            
            if (onAmountChange) {
              onAmountChange(numericValue);
            }
          }}
          helperText={error ? error.message : null}
          size={size}
          name={name}
          sx={sx}
          error={!!error}
          placeholder={placeholder}
          disabled={disabled}
          label={label}
          variant={variant}
          InputProps={
            endAdornmentText
              ? {
                  endAdornment: <AdornmentText position="end">{endAdornmentText}</AdornmentText>,
                }
              : undefined
          }
        />
      )}
    />
  );
};